import { gql } from '@apollo/client';
import { FIND_CACHE_FRAGMENT } from './getMyFindsQuery';

export const UPDATE_FIND_MUTATION = gql`
  mutation UpdateFindMutation($id: String!, $find: FindInput!) {
    updateFind(id: $id, find: $find) {
      ... on UpdateFindSuccess {
        find {
          ...FindCacheFields
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${FIND_CACHE_FRAGMENT}
`;
